var map = {
	"./ai-custom-solution-1.webp": 26729,
	"./ai-custom-solution-2.webp": 75867,
	"./ai-custom-solution-3.webp": 91462,
	"./ai-custom-solution-4.webp": 61081,
	"./ai-custom-solution-5.webp": 69448,
	"./current-platform-1.webp": 89141,
	"./current-platform-10.webp": 66619,
	"./current-platform-11.webp": 95926,
	"./current-platform-12.webp": 58000,
	"./current-platform-13.webp": 21598,
	"./current-platform-14.webp": 5387,
	"./current-platform-2.webp": 56434,
	"./current-platform-3.webp": 53858,
	"./current-platform-4.webp": 14335,
	"./current-platform-5.webp": 67224,
	"./current-platform-6.webp": 42863,
	"./current-platform-7.webp": 68021,
	"./current-platform-8.webp": 57313,
	"./current-platform-9.webp": 47919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15962;